import QRCode from "qrcode"; // 必要：npm install qrcode

// QRコードをbase64 PNG画像に変換
export async function generateQRImage(text) {
  try {
    const dataUrl = await QRCode.toDataURL(text, {
      errorCorrectionLevel: 'H', // 高レベルエラー訂正
      type: 'image/png',
      width: 80, // サイズ調整（px）
      margin: 0, // 余白なし
      scale: 2, // 2倍拡大
    });
    return dataUrl;
  } catch (err) {
    console.error("QRコード画像生成エラー:", err);
    return null;
  }
}
